<template>
  <div class="footerwrap">
    <div class="footer">
      <p class="p1">建设及运维单位：北京鑫创数字科技股份有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;服务电话：400-010-0986</p>
      <!-- <p class="p2">Copyright © www.qstrace.org All Rights Reserved</p> -->
    </div>
  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
    }
  },
  watch:{},
  computed:{},
  methods:{},
  created(){},
  mounted(){}
}
</script>
<style lang="less" scoped>
.footerwrap{
  width: 100%;
  height:80px;
  position: fixed;
  bottom: 0;
  left: 0;
  background:rgba(67,67,67,1);
  text-align: center;
  color:rgba(246,252,252,1);
  .footer {
      .p1 {
        margin:8px 0;
        line-height: 80px;
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue